import * as yup from "yup";

import {
  Button,
  Card,
  CardContent,
  FormControl,
  FormControlLabel,
  Grid,
  Modal,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";

import MentionInput from "../mentions/mention.jsx";
import { REQUIRED_MESSAGE } from "../../../constants";
import React from "react";
import Regex from "../../../utils/validators/regex";
import { clausesStyles } from "./createClausesStyle";
import { getMentions } from "../../../actions/clauses/clauses.action.js";
import { initial } from "lodash";
import { postClause } from "../../../actions/clauses-actions";
import { useForm } from "react-hook-form";
import { useStateValue } from "../../../context/store";
import { yupResolver } from "@hookform/resolvers/yup";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const CreateClauses = (props) => {
  const classes = clausesStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [submitDisabled, setSubmitDisabled] = React.useState(false);
  const [{ breadCrumb }, dispatch] = useStateValue();
  const [mentionsData, setMentionsData] = React.useState([]);
  const [definitionClause, setDefinitionClause] = React.useState("");
  const [isDynamic, setIsDynamic] = React.useState(false);

  const schema = yup.object().shape({
    name: yup
      .string()
      .min(5, "Ingrese mínimo 5 caracteres")
      .max(200, "Ingrese máximo 200 caracteres")
      .matches(/^([^0-9]*)$/, "Ingrese un nombre válido")
      .typeError("Ingrese un nombre válido"),
    definitionClause: yup.string(),
  });

  const { register, handleSubmit, errors, reset, setError, clearErrors } =
    useForm({
      resolver: yupResolver(schema),
    });

  const handleClickClosesuccess = () => {
    props.setMessage({ ...props.message, open: false });
    closeModal();
    props.reset();
    setSubmitDisabled(false);
  };

  const handleClickClose = () => {
    props.setMessage({ ...props.message, open: false });
    setSubmitDisabled(false);
  };

  const resetForm = () => {
    reset();
    setSubmitDisabled(false);
    setDefinitionClause("");
  };

  const handleChangeMentions = (value) => {
    setDefinitionClause(value);

    if (value.length > 0 && value.length < 30) {
      setError("definitionClause", {
        type: "min",
        message: "Ingrese mínimo 30 caracteres",
      });

      return;
    }

    if (value.length > 30 && value.length > 5000) {
      setError("definitionClause", {
        type: "max",
        message: "Ingrese máximo 5000 caracteres",
      });

      return;
    }

    clearErrors("definitionClause");
  };

  const handleClick = async (data) => {
    const result = await postClause(data);

    if (result && (result?.status === 200 || result?.status === 201)) {
      props.setMessage({
        description: `Cláusula creada exitosamente`,
        textButtonSubmit: "Aceptar",
        oneButtons: true,
        handleClick: () => handleClickClosesuccess(),
        type: "SUCCESS",
        open: true,
      });

      resetForm();
      props.reset();

      return;
    }

    if (
      result?.status > 399 &&
      result?.status !== 401 &&
      result?.status !== 403
    ) {
      props.setMessage({
        description: result?.data?.data?.detail
          ? result?.data?.detail
          : "Ocurrió un error procesando la solicitud, inténtelo nuevamente",
        textButtonSubmit: "Aceptar",
        oneButtons: true,
        handleClick: () => handleClickClose(),
        type: "WARNING",
        open: true,
      });

      return;
    }

    props.setMessage({
      description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
      textButtonSubmit: "Aceptar",
      oneButtons: true,
      handleClick: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  };

  const handleRemoveMention = () => {
    setDefinitionClause((state) =>
      state.replace(Regex.DYNAMIC_KEY_PATTERN_GLOBAL, "")
    );

    props.setMessage({ ...props.message, open: false });
  };

  const closeMentionMessage = () => {
    setIsDynamic(true);
    setDefinitionClause(definitionClause);
    props.setMessage({ ...props.message, open: false });
  };

  const handleSwitchChange = (event) => {
    const { checked } = event.target;

    setIsDynamic(checked);
  };

  React.useEffect(() => {
    if (!isDynamic && Regex.DYNAMIC_KEY_PATTERN.test(definitionClause)) {
      props.setMessage({
        description: `Si desactiva la opción de cláusula dinámica, se eliminarán las menciones asociadas a esta cláusula. ¿Está seguro que desea continuar?`,
        textButtonSubmit: "Aceptar",
        handleClick: handleRemoveMention,
        handleClickOut: closeMentionMessage,
        type: "QUESTION",
        open: true,
      });
    }
  }, [isDynamic]);

  const onSubmit = handleSubmit((data) => {
    const { name } = data;

    if (!definitionClause || definitionClause.length <= 0) {
      setError("definitionClause", {
        type: "required",
        message: REQUIRED_MESSAGE,
      });
    }

    if (!name || name.length <= 0) {
      setError("name", {
        type: "required",
        message: REQUIRED_MESSAGE,
      });
    }

    if (
      !definitionClause ||
      !definitionClause ||
      definitionClause.length <= 0 ||
      !name ||
      name.length <= 0
    ) {
      return;
    }

    setSubmitDisabled(true);

    props.setMessage({
      description: `¿Está seguro que desea crear la cláusula?`,
      textButtonSubmit: "Aceptar",
      handleClick: () => handleClick({ name, definitionClause, isDynamic }),
      handleClickOut: () => handleClickClose(),
      type: "WARNING",
      open: true,
    });
  });

  const closeModal = () => {
    resetForm();

    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Gestionar cláusulas",
      breadCrumbSubText: "Gestionar cláusulas",
      index: 10,
      open: false,
      isButtonCreate: true,
    });
  };

  React.useEffect(() => {
    getMentions().then((response) => {
      if (response && response.status === 200) {
        setMentionsData(response.data);
      }
    });
  }, []);

  const bodyModal = (
    <div style={modalStyle} className={classes.paper}>
      <Card
        className={classes.card}
        elevation={0}
        style={{ overflow: initial }}
      >
        <CardContent>
          <Typography className={classes.titleCreate}>
            Crear cláusula
          </Typography>

          <form onSubmit={onSubmit} className={classes.form} autocomplete="off">
            <Grid
              container
              spacing={3}
              direction="column"
              alignItems="flex-start"
            >
              <Grid item xs={12} md={12} lg={9} style={{ width: "inherit" }}>
                <FormControl
                  fullWidth
                  size="small"
                  shrink={true}
                  notched={true}
                >
                  <TextField
                    fullWidth
                    native
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    className={classes.dropdown}
                    inputRef={register}
                    type="text"
                    label="Nombre de cláusula *"
                    name="name"
                    error={
                      errors.hasOwnProperty("name") && errors["name"].message
                    }
                    helperText={
                      errors.hasOwnProperty("name") && errors["name"].message
                    }
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={12} lg={12} style={{ width: "inherit" }}>
                <MentionInput
                  mentions={isDynamic ? mentionsData : []}
                  inputChange={handleChangeMentions}
                  preValue={definitionClause}
                  label="Definición de cláusula *"
                  isError={
                    !!errors.hasOwnProperty("definitionClause") &&
                    !!errors["definitionClause"].message
                  }
                  errorMessage={
                    errors.hasOwnProperty("definitionClause") &&
                    errors["definitionClause"].message
                  }
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <FormControlLabel
                  fullWidth
                  size="small"
                  shrink={true}
                  notched={true}
                  control={
                    <Switch
                      title="¿Es dinamica?"
                      name="isDynamic"
                      checked={isDynamic}
                      color="primary"
                      onChange={handleSwitchChange}
                    />
                  }
                  label="¿Es dinámica?"
                />
              </Grid>

              <Grid
                item
                xs={12}
                md={12}
                lg={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <Button
                  variant="outlined"
                  style={{ backgroundColor: "transparent", color: "#7EBDCE" }}
                  onClick={closeModal}
                >
                  REGRESAR
                </Button>
                <Button
                  variant="outlined"
                  type="submit"
                  disabled={submitDisabled}
                  style={{
                    backgroundColor: "#7EBDCE",
                    border: "none",
                    color: "#ffffff",
                  }}
                >
                  GUARDAR
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <div>
      <Modal
        style={{ textAlign: "center" }}
        open={breadCrumb?.open}
        // aria-labelledby="simple-modal-title"
        // aria-describedby="simple-modal-description"
      >
        {bodyModal}
      </Modal>
    </div>
  );
};

export default CreateClauses;
